export const tabData = [
  {
    name: "Meeting Room",
    className: "bg-purple-200",
    popoverTitle:
      "Meeting Room: Your own meeting room or event space in a coworking space.",
    popoverDescription:
      "Get hours of focus with clients or have an offsite meeting with your team in a staffed coworking space environment.",
    popoverList: [
      "Ideal for 2-20 person (starts 50 sq. ft.)",
      "Secure conference- or classroom-style",
      "Per-Hour, No Commitment Room Booking",
      "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
      "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours",
    ],
  },
  {
    name: "Private Office",
    className: "bg-blue-200",
    popoverTitle: "Private Office: Your own flex office in a coworking space.",
    popoverDescription:
      "Experience privacy with the team with your own office room in a staffed coworking space environment.",
    popoverList: [
      "Ideal for 2-10 people (starts 150 sq. ft.) ",
      "Secure, private podcast- or standard-style offices",
      "Per-Day, No Lease Office Booking",
      "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
      "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours",
    ],
  },
  {
    name: "Flexday Suite",
    className: "bg-red-200",
    popoverTitle: "Flexday Suite: Your own flex office for a day (or three).",
    popoverDescription:
      "Vibe with your whole company in your own fully-equipped, private office suite with multiple space configurations.",
    popoverList: [
      "Ideal for 5-50 people (starts 700 sq. ft.)",
      "Secure, private podcast-style or full team office suites w/ sub-rooms and spaces",
      "Per-Day to Short-Term, No Lease Office Booking",
      "Basic Amenities: Wifi, Coffee/Tea, Kitchen Appliances (Microwave, Fridge), Washrooms, Cleaning",
      "By Request: Office Supplies, White Board, A/V Equipment, TV, Catering, Extended Hours",
    ],
  },
]

export const tabOptions = {
  MeetingRoom: "Meeting Room",
  PrivateOffice: "Private Office",
  FlexdaySuite: "Flexday Suite",
}
